import type { Reviews_Bool_Exp } from '@graphql/__generated__/graphql';

/**
 * Same rule as the agency page's `combined_reviews` filter for RealAdvisor
 * reviews (agency-pages adds Google reviews on top) and as
 * `teams_ranking_stats.team_reviews` (hasura-crm migration
 * 1790259442000_teams_ranking_stats_mv), which feeds the neighbours' figures and
 * the monthly performance mail: keep the three in step.
 */
export const getTeamReviewsWhere = (teamId: string): Reviews_Bool_Exp => ({
  completed: { _eq: true },
  _or: [
    { user: { default_team_id: { _eq: teamId } } },
    {
      user: {
        show_in_agency_pages: { _eq: true },
        teams_users: {
          team_id: { _eq: teamId },
          deactivated: { _eq: false },
        },
      },
    },
  ],
});
